<template>
  <div>
    <a
      href="javascript:void(0);"
      :class="rtClass"
      class="text-link --bare lightbox ad-disclosure mobile-rate-table__ad-disclosure"
      v-on:click.stop="showDisclosure"
    >
      {{ linkText }}
    </a>
    <div class="tool-tip mobile-rate-table__tool-tip">
      <div
        :class="'tool-tip__box ' + tooltipBoxClass"
        v-show="shownDisclosure"
        v-on:click="showDisclosure"
      >
        <div class="tool-tip__arrow"></div>
        <div class="tool-tip__content" v-html="copy"></div>
      </div>
    </div>
  </div>
</template>
<script>
import eventHub from '../bankrate-events/index'

// @DEPRECATED - Rewrite or clean up for any future use
export default {
  props: {
    copy: {
      default: ''
    },
    linkText: {
      default: ''
    },
    direction: {
      default: ''
    },
    statement: {
      default: ''
    },
    rtClass: {
      default: 'rate-table__row-copy'
    }
  },

  data: function() {
    return {
      shownDisclosure: false
    }
  },

  created: function() {
    eventHub.$on('adDisclosure::close', this.hideDisclosure)
  },

  computed: {
    tooltipBoxClass: function() {
      return (
        (this.direction ? '--' + this.direction : '') +
        (this.statement ? '--rightoffset' : '')
      )
    }
  },

  methods: {
    showDisclosure: function() {
      eventHub.$emit('tooltip::close')
      if (this.shownDisclosure === true) {
        this.shownDisclosure = false
      } else {
        eventHub.$emit('adDisclosure::close')
        this.shownDisclosure = true
        // add ga tracking only for statement == true, meaning the component is rendering for "offer details"
        // and not the actual "Advertising Disclosure" outside the table.
        if (this.statement === true) {
          // GA tracking for clicking "offer details"
          eventHub.$emit('rateTable.offerDetails')
        }
      }
    },
    hideDisclosure: function() {
      this.shownDisclosure = false
    }
  }
}
</script>
